var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMcYlogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38 33",
    style: {
      enableBackground: "new 0 0 38 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.34,
    height: 33.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.68,25.21v-0.4c0-0.72-0.23-0.95-0.99-0.95h-2.56c-0.76,0-0.99,0.22-0.99,0.95v1.98 c0,0.72,0.23,0.95,0.99,0.95h2.56c0.76,0,0.99-0.22,0.99-0.95v-0.51h-0.99v0.63h-2.56v-2.26h2.56v0.56H21.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.23,23.87v3.05h-2.37v-3.05h-0.99v2.92c0,0.72,0.23,0.95,0.99,0.95h2.37c0.76,0,0.99-0.22,0.99-0.95 v-2.92H26.23z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.6,23.87 35.4,25.21 34.2,23.87 32.87,23.87 34.9,26.02 34.9,27.73 35.89,27.73 35.89,26.02  37.92,23.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.5,23.87 2.93,26.07 1.37,23.87 0.42,23.87 0.42,27.73 1.4,27.73 1.4,25.35 2.54,27.03 3.33,27.03  4.47,25.35 4.47,27.73 5.44,27.73 5.44,23.87  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.71,26.32h0.33c0.62,0,0.9-0.24,0.9-0.79v-0.88c0-0.54-0.28-0.79-0.9-0.79h-3.27v3.87h0.98v-3.1h1.9 c0.27,0,0.33,0.05,0.33,0.24v0.45c0,0.19-0.07,0.24-0.33,0.24h-1.26v0.73l1.77,1.45h1.29L14.71,26.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.25,26.32h0.33c0.62,0,0.9-0.24,0.9-0.79v-0.88c0-0.54-0.28-0.79-0.9-0.79h-3.27v3.87h0.98v-3.1h1.9 c0.27,0,0.33,0.05,0.33,0.24v0.45c0,0.19-0.07,0.24-0.33,0.24h-1.26v0.73l1.77,1.45h1.29L31.25,26.32z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.64,24.62 10.64,23.87 6.67,23.87 6.67,27.73 10.64,27.73 10.64,26.91 7.66,26.91 7.66,26.1  10.26,26.1 10.26,25.34 7.66,25.34 7.66,24.62  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8.24,31.92 8.24,29.39 7.42,29.39 7.42,32.61 10.58,32.61 10.58,31.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22.27,29.39 22.27,30.04 23.71,30.04 23.71,32.61 24.54,32.61 24.54,30.04 25.98,30.04  25.98,29.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.54,29.39h-2.3c-0.63,0-0.82,0.18-0.82,0.79v1.65c0,0.6,0.19,0.79,0.82,0.79h2.3 c0.63,0,0.82-0.18,0.82-0.79v-1.65C30.37,29.57,30.17,29.39,29.54,29.39z M29.54,30.04v1.88h-2.3v-1.88H29.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.3,29.39 17.05,31.6 15.8,29.39 14.92,29.39 16.74,32.61 17.37,32.61 19.19,29.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.69,31.43h0.27c0.52,0,0.75-0.2,0.75-0.66v-0.73c0-0.45-0.23-0.66-0.75-0.66h-2.73v3.22h0.81v-2.58h1.58 c0.22,0,0.28,0.04,0.28,0.2v0.38c0,0.16-0.06,0.2-0.28,0.2h-1.05v0.61l1.46,1.2l0.01,0.01h1.07L33.69,31.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.03,29.41 21.01,29.39 20.23,29.39 18.41,32.61 19.3,32.61 20.62,30.27 21.93,32.59 21.95,32.61  22.84,32.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6.56,30.01 6.56,29.37 3.24,29.37 3.24,32.61 6.56,32.61 6.56,31.92 4.07,31.92 4.07,31.24  6.24,31.24 6.24,30.61 4.07,30.61 4.07,30.01  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14.59,30.01 14.59,29.37 11.27,29.37 11.27,32.61 14.59,32.61 14.59,31.92 12.1,31.92 12.1,31.24  14.27,31.24 14.27,30.61 12.1,30.61 12.1,30.01  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.17,3.41c3.12,0,6.03,0.6,8.44,1.64l-8.44-4.11l-8.44,4.11C13.15,4.01,16.05,3.41,19.17,3.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "28.43,9.45 28.43,5.44 19.5,9.95 19.5,22.25 28.43,17.74 28.43,14.57 22.67,17.48 22.67,16.92  28.43,14.01 28.43,10.01 22.67,12.92 22.67,12.36  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.92,5.44 9.92,17.74 12.41,19 12.41,11.17 12.91,11.43 12.91,19.25 15.47,20.54 15.47,12.72  15.97,12.97 15.97,20.8 18.85,22.25 18.85,9.95  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcYlogoWhite);
export default __webpack_public_path__ + "static/media/MCYlogo_white.cb3ed5ac01c851b2a84305e647f4fc34.svg";
export { ForwardRef as ReactComponent };